import { List, Record } from "immutable";
import { type TTicketDuration } from "utils/durationsOptions";

import { IntegrationActorPermissionModel } from "./IntegrationActorPermissionModel";
import { IntegrationResourceModel } from "./IntegrationResourceModel";

const defaults = {
  allowedDurations: null as List<TTicketDuration> | null,
  approvalAlgorithmId: null as null | string,
  eligible: false,
  euid: "",
  givesAccessToRoles: null as List<IntegrationResourceRoleModel> | null,
  hasAccessFromResources: null as List<IntegrationResourceModel> | null,
  hasAccessFromRoles: null as List<IntegrationResourceRoleModel> | null,
  id: "",
  integrationActorPermissions: null as List<IntegrationActorPermissionModel> | null,
  integrationResource: null as IntegrationResourceModel | null,
  integrationResourceId: "",
  isDeleted: false,
  managed: false,
  name: "",
  permissions: null as null | string[],
  prerequisitePermissionId: null as null | string,
  requestable: false,
  virtualizedRole: null as IntegrationResourceRoleModel | null,
  virtualizedRoleId: null as null | string,
  virtualOfRoleIds: null as null | string[],
};

export type TIntegrationResourceRoleModel = typeof defaults;

export class IntegrationResourceRoleModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown): IntegrationResourceRoleModel {
    const {
      allowedDurations,
      approvalAlgorithmId,
      eligible,
      euid,
      givesAccessToRoles: giveAccessToRoles,
      hasAccessFromResources,
      hasAccessFromRoles,
      id,
      integrationActorPermissions,
      integrationResource,
      integrationResourceId,
      isDeleted,
      managed,
      name,
      permissions,
      prerequisitePermissionId,
      requestable,
      virtualizedRole,
      virtualizedRoleId,
      virtualOfRoleIds,
    } = data as typeof defaults;

    return new IntegrationResourceRoleModel({
      allowedDurations: allowedDurations ? List(allowedDurations) : null,
      approvalAlgorithmId,
      eligible,
      euid,
      givesAccessToRoles: giveAccessToRoles
        ? List(giveAccessToRoles.map(IntegrationResourceRoleModel.fromServerData))
        : null,
      hasAccessFromResources: hasAccessFromResources
        ? List(hasAccessFromResources.map(IntegrationResourceModel.fromServerData))
        : null,
      hasAccessFromRoles: hasAccessFromRoles
        ? List(hasAccessFromRoles.map(IntegrationResourceRoleModel.fromServerData))
        : null,
      id,
      integrationActorPermissions: integrationActorPermissions
        ? List(integrationActorPermissions.map(IntegrationActorPermissionModel.fromServerData))
        : null,
      integrationResource: integrationResource ? IntegrationResourceModel.fromServerData(integrationResource) : null,
      integrationResourceId,
      isDeleted,
      managed,
      name,
      permissions,
      prerequisitePermissionId,
      requestable,
      virtualizedRole: virtualizedRole ? IntegrationResourceRoleModel.fromServerData(virtualizedRole) : null,
      virtualizedRoleId,
      virtualOfRoleIds,
    });
  }
}
